import React from 'react';
import ExclamationIcon from '../Icons/ExclamationIcon';

const ErrorMessagge = ({ error = '' }) => {
  if (error === '') return null;
  return (
    <div className="error-wrapper">
      <p>
        <ExclamationIcon />
        {error}
      </p>
    </div>
  );
};

export default ErrorMessagge;
